<div class="gob-notification-container">
  <div id="myToast" class="gob-toast" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-content">
      <div class="toast-icon">
        <img src="/assets/img/skin/star.png" alt="gobelin"/>
      </div>
      <div class="toast-body-wrapper">
        <div class="toast-header-custom">
          <strong class="title">{{notif.title}}</strong>
          <button type="button" class="btn-close-custom" (click)="hideToast()">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="toast-message">
          {{notif.message}}
        </div>
      </div>
    </div>
    <div class="progress-bar"></div>
  </div>
</div>